/* eslint-disable import/prefer-default-export */

export const PrioritiesEnum = {
  Manual: 11, // source picked manually from dashboard
  Overidden: 10, // value overriden from dashboard
};

export const propertyPriorityBySource = (record, property, source) =>
  record?.priorities?.[property]?.[source];
